module.exports = __webpack_public_path__ + "img/itx-file-type-mov.1d313d63.svg";